// extracted by mini-css-extract-plugin
export default {"loadMoreContainer":"PrimeCommunityPostsContainer_loadMoreContainer__EaHCH","loadMoreButton":"PrimeCommunityPostsContainer_loadMoreButton__PDDE6"};